import React from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './Routes';
import { ConfigProvider as AppConfigProvider } from './contexts/ConfigContext';
import { UserProvider } from './contexts/UserContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { SWRConfig, mutate } from 'swr';
import { ConfigProvider as AntConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import 'antd/dist/reset.css';
import './index.css';

const domNode = document.getElementById('root') as HTMLElement;
const root = createRoot(domNode);

root.render(
  <SWRConfig
    value={{
      onError: (error) => {
        if (error?.status === 240) {
          mutate(
            (k) => Array.isArray(k) && typeof k[0] === 'string' && k[0].includes('/security/auth/'),
            undefined,
            { revalidate: true }
          );
        }
      }
    }}
  >
    <AntConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
        },
      }}
    >
      <AppConfigProvider>
        <UserProvider>
          <CompanyProvider>
            <Routes />
          </CompanyProvider>
        </UserProvider>
      </AppConfigProvider>
    </AntConfigProvider>
  </SWRConfig>
);
